import { ReportStep } from "@/models/graphql-global-types";

export const sortASC = (a: any, b: any) => {
  if (a < b) {
    return -1;
  } else if (a > b) {
    return 1;
  } else {
    return 0;
  }
};

export const sortDESC = (a: any, b: any) => {
  if (a < b) {
    return 1;
  } else if (a > b) {
    return -1;
  } else {
    return 0;
  }
};

export const sortReportStep = (a: ReportStep, b: ReportStep) => {
  if (a < b) {
    return 1;
  } else if (a > b) {
    return -1;
  } else {
    return 0;
  }
};
